import React from 'react'
import { Row, Col } from 'reactstrap';
import { Dialog } from 'primereact/dialog';
import { ConfigServer } from '../../data/config'
import '../Invoice/dialogStyle.css'

export const DialogPreviewCreditNote = (props) => {

	const { showPreview, setShowPreview, listCommercialLines, informationCLient, formCreditNote, FormatNumbers, totalFooter, listSettings } = props;

	const commercialLineId = localStorage.getItem('commercialLineId');
	const emisor = listCommercialLines?.find(c => c.value == commercialLineId);
	const firstConcept = formCreditNote.listConcepts?.[0]?.concept;
	const firstTotal = formCreditNote.listConcepts?.[0]?.subtotal;
	const firstImport = formCreditNote.listConcepts?.[0]?.unit_price;


	return (
		<Dialog
			visible={showPreview}
			modal
			onHide={() => setShowPreview(false)}
			style={{ width: '80vw', maxWidth: '900px', borderRadius: '16px' }}
			headerStyle={{
				background: 'linear-gradient( #0d3b59)',
				color: 'white',
				fontWeight: 'bold',
				borderRadius: '12px 12px 0 0'
			}}
			pt={{
				header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
				headerIcon: { style: { color: 'white' } },
			}}
		>
			<div style={{ fontSize: '10px', color: '#333' }}>
				{/* ENCABEZADO */}
				<Row style={{ paddingBottom: '15px', marginBottom: '15px', alignItems: 'center' }}>
					<Col sm="4" style={{ textAlign: 'center' }}>
						<img src={ConfigServer.serverUrl + "/api/Configuration/Logo"} style={{ width: "65%", borderRadius: '8px' }} alt="Invoice" />
					</Col>
					<Col sm="8" style={{ textAlign: 'center' }}>
						<div style={{ fontSize: '20px', fontWeight: 'bold', color: '#0d3b59' }}>{emisor?.label ?? ''}</div>
						<div style={{ fontSize: '14px', color: '#2b2b2bff' }}>RFC: {emisor?.rfc ?? ''}</div>
						<div style={{ fontSize: '14px', color: '#2b2b2bff' }}>{emisor?.code_tax_regime ?? ''}-{emisor?.name_tax_regime ?? ''}</div>
						<div style={{ fontSize: '14px', color: '#2b2b2bff' }}>{emisor?.address ?? ''}, {emisor?.colony ?? ''}, C.P. {emisor?.cpBranch ?? ''}</div>

					</Col>
				</Row>
				<Row style={{ marginBottom: '20px' }}>
					<Col sm="6" className="shadow-sm"
						style={{
							backgroundColor: 'white', border: '1px solid #e0e0e0',
							borderRadius: '10px', padding: '12px', fontSize: '12px'
						}}>
						<div style={{
							fontWeight: 'bold', background: '#f59e0b', color: 'white',
							padding: '6px', borderRadius: '8px', marginBottom: '10px',
							textAlign: 'center', fontSize: '12px'
						}}>

							RECEPTOR
						</div>
						<p style={{ fontSize: '11px', margin: '2px 0' }}>
							<strong>{informationCLient?.name_commercial_line}</strong>
						</p>
						<p style={{ fontSize: '11px', margin: '2px 0' }}>
							<strong>RFC:</strong> {informationCLient?.rfc ?? ''}
						</p>
						<p style={{ fontSize: '11px', margin: '2px 0' }}>
							<strong>Domicilio:</strong> {informationCLient.cp ?? ''}
						</p>
						<p style={{ fontSize: '11px', margin: '2px 0' }}>
							<strong>*Uso:</strong> {" G02 - Devoluciones, descuentos o bonificaciones"}
						</p>

					</Col>
					<Col sm="1">
					</Col>

					<Col sm="5" className="shadow-sm"
						style={{
							backgroundColor: 'white', border: '1px solid #e0e0e0',
							borderRadius: '10px', padding: '12px', fontSize: '12px'
						}}>
						<div style={{
							fontWeight: 'bold', background: '#0d3b59', color: 'white',
							padding: '6px', borderRadius: '8px', marginBottom: '10px',
							textAlign: 'center', fontSize: '12px'
						}}>
							NOTA DE CRÉDITO #

						</div>
						<Row style={{ fontSize: '12px', textAlign: 'left', lineHeight: '1.3' }}>
							<Col sm="2">
							</Col>

							<Col sm="10" style={{ textAlign: "end" }} >
								{
									listSettings?.length > 0 && <>
										<p className="m-0">
											<b>Sucursal:</b>	{listSettings?.[0]?.branch_name ?? ""}
										</p>
										<p className="m-0">
											<b>Folio:</b>	{listSettings?.[0]?.serie ?? ""} {listSettings?.[0]?.folio ?? ""}
										</p>
									</>
								}
								{
									listSettings?.length === 0 && <div
										style={{
											color: "#856404",
											fontSize: "0.78rem",
											marginTop: "6px",
											fontWeight: "500",
											backgroundColor: "#fff3cd",
											padding: "4px 10px",
											borderRadius: "6px",
											boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
											display: "flex",
											alignItems: "center",
											gap: "6px",
											border: "1px solid #ffeeba",
										}}
									>
										<i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
										{"No se a configurado ningún folio para poder emitir." ?? "---"}
									</div>
								}

								<p style={{ fontSize: '11px', margin: '2px 0' }}>
									<strong>*Tipo de comprobante: E - Egreso</strong>
								</p>
								<p style={{ fontSize: '11px', margin: '2px 0' }}>
									<strong>Versión 4.0</strong>
								</p>
								<p style={{ fontSize: '11px', margin: '2px 0' }}>
									<strong>Fecha y hora de emisión:</strong>
								</p>
								<p style={{ fontSize: '11px', margin: '2px 0' }}>
									<strong>No. de Serie del Certificado</strong> XXXXXXXXXXXXX
								</p>
								<p style={{ fontSize: '11px', margin: '2px 0' }}>
									<strong>Moneda MXN - Peso Mexicano</strong>
								</p>
							</Col>

						</Row>
					</Col>
				</Row>
				<Row>
					<Col sm="12" className='shadow-sm' style={{ backgroundColor: 'white', border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px' }}>
						<table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
							<tbody>
								<tr style={{ backgroundColor: '#f9f9f9' }}>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Cantidad</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Código</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Clv-Unidad</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Clv-Concepto</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>P. Unitario</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Importe</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Descuento</th>
								</tr>
								<tr>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>1</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}></td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>E48</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>84111506-t{firstConcept}</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>{firstImport}</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>{firstTotal}</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}></td>
								</tr>
							</tbody>
						</table>
					</Col>
				</Row>
				<Row className="mt-3">
					<Col sm="6" className="shadow-sm" style={{ backgroundColor: 'white', border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px' }}>
						<div style={{
							border: '1px solid #ccc',
							padding: '6px',
							fontWeight: 'bold',
							color: '#181818ff',
							textAlign: 'left',
							lineHeight: '1.6'
						}}>
							Folio Fiscal: XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX <br />
							Fecha y hora de certificación:  <br />
							Lugar de expedición: {emisor?.cpBranch ?? ''}
						</div>
					</Col>
					<Col sm="6" className="shadow-sm" style={{ backgroundColor: 'white', border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px' }}>
						<table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
							<tbody>
								<tr style={{ backgroundColor: '#f9f9f9' }}>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Subtotal</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Total</th>
								</tr>
								<tr>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>$ {FormatNumbers(totalFooter.subtotal, 2)}</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>$ {FormatNumbers(totalFooter.total, 2)}</td>
								</tr>
							</tbody>
						</table>
					</Col>
				</Row>
			</div>
		</Dialog>
	)
}
